import '../../styles/Experience.css';

export function Experience({ experience }) {
  const girlsTablet = `img/${experience.img}`; 
  return(
    <>
      <section className="hero is-medium is-warning component-container back-ground"
        style={{backgroundImage:`url(${girlsTablet})`}}>
        <div className="hero-body" id='experiencia'>

          <div className="container has-text-centered text-container">
            <p className="title">
              {experience.title}
            </p>
            <p className="subtitle">
              {experience.text}
            </p>
          </div>

        </div>
      </section>
    </>
  );
}